import styled from "styled-components";
// components
import { LinkText } from "../link";
// utils
import { getIconSize, getIconPadding, getLinkSize } from "./breadcrumb.utils";
export const BreadcrumbContainer = styled.div `
  &.breadcrumb {
    display: flex;
    align-items: center;
    font-weight: ${({ theme }) => theme.fontWeights.medium};

    // size of text link element
    span {
      ${({ size }) => getLinkSize({ size })};
    }
  }
`;
export const DisabledLink = styled.span `
  color: ${({ theme }) => theme.colors.grey12};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
`;
export const StyledLinkItem = styled.div `
  &.breadcrumb-item {
    display: flex;
    align-items: center;

    &&& {
      // text link element
      a {
        box-sizing: border-box;
        min-width: auto;
        padding: ${({ size }) => (size === "big" || size === "huge" ? "0 0.5rem" : "0 0.375rem")};
        
        ${({ size }) => getIconPadding({ size })};

        & span > svg {
          ${({ size }) => getIconSize({ size })};
          fill: ${({ theme }) => theme.colors.grey15};
        }

        &:active {
          ${({ theme }) => theme.global.disableTapHighlight}

          span {
            color: ${({ theme }) => theme.colors.white};
          }

          svg {
            fill: ${({ theme }) => theme.colors.white};
          }
        }

        span {
          color: ${({ theme }) => theme.colors.grey15};
        }

        &:hover {
          ${({ theme }) => `background: rgba(${theme.colors.transparentBlack},0.08);`};
        }

        &:active {
          background: ${({ theme }) => theme.colors.grey15};
        }
      }

      ${({ hasText }) => (hasText && `
        span:last-child {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      `)};
    }

    // icons -> home & arrows
    span {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    // arrows
    &&& {
      & span > svg {
        ${({ size }) => getIconSize({ size })};
      }
    }

    &:not(:last-child) > span + span {
      margin-right: 0.375rem;
      min-height: 0 !important; // necessary
    }

    &:not(:first-child) > span + span {
      margin-left: 0.375rem;
    }

    ${LinkText}, ${DisabledLink} {
      width: auto;
      height: auto;
    }
  }
`;
export const StyledHomeLinkItem = styled(StyledLinkItem) `
  &.breadcrumb-item {
    &&& {
      a {
        padding-left: 0;
        min-width: unset;
        ${({ hasText }) => (!hasText && "padding: 0")};
      }

      span:not(${LinkText}) {
        ${({ size }) => getIconPadding({ size })};
      }
    }
  }
`;
